import "@resources/styles/app.css";
import React from "react";
import { AnimatePresence, domMax, LazyMotion } from "framer-motion";
import ThemeContext from "@/contexts/theme";
import Board from "@/layouts/partials/board";
import Footer from "@/layouts/partials/footer";
import Header from "@/layouts/partials/header";
import Noise from "@/layouts/partials/noise";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => (
  <LazyMotion features={domMax}>
    <div className="overflow-hidden">
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex flex-col items-stretch justify-center flex-1">
          {children}
        </main>
      </div>
      <ThemeContext.Consumer>
        {({ boardVisible }) => (
          <AnimatePresence>{boardVisible && <Board />}</AnimatePresence>
        )}
      </ThemeContext.Consumer>
      <Footer />
      <Noise />
    </div>
  </LazyMotion>
);

export default Layout;
